import { Badge } from "./Badge.js";

interface LeaderboardFilterChipsProps {
  game?: string | null;
  eventIds?: string[] | null;
  tracks?: string[] | null;
  cars?: string[] | null;
  dateFrom?: string | null;
  dateTo?: string | null;
  /** Optional: append a venue-scope chip (used on cloud cross-venue rows). */
  venueScopeLabel?: string;
  /** Customise the empty-state label. Defaults to "All". */
  emptyLabel?: string;
}

/**
 * Renders a compact badge row summarising a leaderboard's active filters.
 * Shared between hub-ui (LeaderboardManagementList) and cloud-ui
 * (VenueLeaderboards, OrgLeaderboards, LeaderboardDetailModal).
 */
export function LeaderboardFilterChips({
  game,
  eventIds,
  tracks,
  cars,
  dateFrom,
  dateTo,
  venueScopeLabel,
  emptyLabel = "All",
}: LeaderboardFilterChipsProps) {
  const chips: string[] = [];
  if (venueScopeLabel) chips.push(venueScopeLabel);
  if (tracks && tracks.length) chips.push(`${tracks.length} track${tracks.length > 1 ? "s" : ""}`);
  if (cars && cars.length) chips.push(`${cars.length} car${cars.length > 1 ? "s" : ""}`);
  if (game) chips.push(String(game));
  if (eventIds && eventIds.length) {
    chips.push(`${eventIds.length} event${eventIds.length > 1 ? "s" : ""}`);
  }
  if (dateFrom || dateTo) {
    chips.push([dateFrom ?? "...", dateTo ?? "..."].join(" - "));
  }

  if (chips.length === 0) {
    return <span className="text-gray-400 text-xs">{emptyLabel}</span>;
  }

  return (
    <div className="flex flex-wrap gap-1">
      {chips.map((c) => (
        <Badge key={c}>{c}</Badge>
      ))}
    </div>
  );
}
